import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { PhoneInput, TextInput, TextareaInput, RadioselectInput } from '@/components/inputs';
import { addPrefixToDataParams } from '@/utils/string';
import { Button } from '@/components/buttons';
import { useForm } from '@formspree/react';
import CheckIcon from '@/assets/icons/heroIcons/CheckCircle.svg';
import { Link } from '@/components/links';
import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
import { required, email, phone, pipeValidators } from '@/utils/validators';
import { logEvent } from '@/analytics/events';
import { SectionHeadline } from '@/components/SectionHeadline';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
export const ContactForm = () => {
  const $ = _c(29);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["cssProgram", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const [state, handleSubmitForm] = useForm("mwkgqjyk");
  const isHuLanguage = useIsSelectedLanguage("hu");
  if (state.succeeded) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CheckIcon className="mx-auto h-16 w-16 text-blue-500" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t) {
      t2 = t("core:forms.success.title");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <h2 className="mt-8 mb-3 text-3xl font-bold">{t2}</h2>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <br />;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t) {
      t5 = <p><Trans t={t} i18nKey="core:forms.success.text">{t4}</Trans></p>;
      $[7] = t;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
      t6 = <div className="rounded-xl bg-white px-4 py-6 text-center lg:rounded-4xl lg:p-12">{t1}{t3}{t5}</div>;
      $[9] = t3;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t1;
  if ($[12] !== t) {
    t1 = t("cssProgram:form.title");
    $[12] = t;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== t1) {
    t2 = <SectionHeadline className="mb-12 lg:mb-16" variant="inverted" anchorKey="cssProgram.form.title">{t1}</SectionHeadline>;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== handleSubmitForm) {
    t3 = data => {
      logEvent("generate_lead", {
        action: "cssProgram"
      });
      setTimeout(() => {
        handleSubmitForm(data);
      });
    };
    $[16] = handleSubmitForm;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      _subject: "Zapojen\xED do CSS Programu",
      _language: "cs"
    };
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== isHuLanguage || $[20] !== state.submitting || $[21] !== t) {
    t5 = t6 => {
      const {
        handleSubmit
      } = t6;
      return <form method="post" onSubmit={handleSubmit} {...addPrefixToDataParams({
        analyticsParam: "cssProgramContact",
        testId: "cssProgramContact",
        prefix: "form"
      })}><div className="mb-10 flex flex-col gap-8"><div className="flex flex-col gap-4"><p className="font-semibold">{t("cssProgram:form.sections.1.title")}</p><div className="flex flex-col gap-4 md:flex-row"><div className="w-full"><Field name="name" validate={required} initialValue="">{fieldRenderProps => <TextInput {...fieldRenderProps} label={t("core:forms.fields.name")} />}</Field></div><div className="w-full"><Field name="surname" validate={required} initialValue="">{fieldRenderProps_0 => <TextInput {...fieldRenderProps_0} label={t("core:forms.fields.surname")} />}</Field></div></div><Field name="eshop" type="text" validate={pipeValidators(required)}>{fieldRenderProps_1 => <TextInput {...fieldRenderProps_1} label={t("core:forms.fields.eshop")} />}</Field><Field name="email" type="email" validate={pipeValidators(required, email)}>{fieldRenderProps_2 => <TextInput {...fieldRenderProps_2} label={t("core:forms.fields.email")} />}</Field><Field name="phone" type="tel" validate={pipeValidators(required, phone)}>{fieldRenderProps_3 => <PhoneInput {...fieldRenderProps_3} label={t("core:forms.fields.phone")} />}</Field></div><div className="flex flex-col gap-4"><p className="font-semibold">{t("core:forms.source.title")}</p><Field name="source" initialValue={t("core:forms.source.options.1")}>{fieldRenderProps_4 => <RadioselectInput variant="onRow" {...fieldRenderProps_4} options={isHuLanguage ? [t("core:forms.source.options.1"), t("core:forms.source.options.3"), t("core:forms.source.options.4"), t("core:forms.source.options.5"), t("core:forms.source.options.6"), t("core:forms.source.options.7"), t("core:forms.source.options.other")] : [t("core:forms.source.options.1"), t("core:forms.source.options.2"), t("core:forms.source.options.3"), t("core:forms.source.options.4"), t("core:forms.source.options.5"), t("core:forms.source.options.6"), t("core:forms.source.options.7"), t("core:forms.source.options.other")]} />}</Field></div><div className="flex flex-col gap-4"><p className="font-semibold">{t("cssProgram:form.sections.2.title")}</p><Field name="message">{fieldRenderProps_5 => <TextareaInput {...fieldRenderProps_5} label={t("core:forms.fields.message")} />}</Field></div></div><Text variant="p4" className="mb-6 text-center text-gray-600 lg:mb-10"><Trans t={t} i18nKey="cssProgram:form.conditions"><Link testId="informationMemorandum" analyticsParam="informationMemorandum" to={LINKS().informationMemorandum} /></Trans></Text><Button type="submit" analyticsParam="submitForm" testId="submitForm" variant="primary" align="center" size="lg" busy={state.submitting}>{t("core:forms.fields.submit")}</Button></form>;
    };
    $[19] = isHuLanguage;
    $[20] = state.submitting;
    $[21] = t;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t3 || $[24] !== t5) {
    t6 = <div className="rounded-xl bg-white px-4 py-6 lg:rounded-4xl lg:p-12"><Form onSubmit={t3} initialValues={t4}>{t5}</Form></div>;
    $[23] = t3;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t2 || $[27] !== t6) {
    t7 = <div className="pt-14 lg:pt-20">{t2}{t6}</div>;
    $[26] = t2;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};